// formatAddress(addr)
// VOS stores address in two shapes depending on which UI created the user:
//   • Legacy / Profile flow → flat string ("Mumbai, Maharashtra")
//   • EmployeeOnboardModal  → object { street, city, state, pincode, country, landmark }
//
// Anywhere we render the address we MUST coerce both shapes to a single
// string — otherwise React crashes with error #31 ("Objects are not valid
// as a React child").
//
// Returns "" when nothing is provided so callers can chain `addr || '-'`.

export function formatAddress(addr) {
  if (!addr) return '';
  if (typeof addr === 'string') return addr.trim();
  if (typeof addr !== 'object') return String(addr);
  const parts = [
    addr.street,
    addr.landmark,
    addr.city,
    addr.state,
    addr.pincode,
    addr.country,
  ].map(p => (p ? String(p).trim() : '')).filter(Boolean);
  return parts.join(', ');
}
